import { Filter } from "@/shared/lib/filter/filter";
import { backendApi } from "../../api";
import { GesecCustomer } from "../types/gesec-customer";
import { ODataList } from "./odata-list";

const customerApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    businessCentralGesecCustomerShow: build.query<
      GesecCustomer,
      ShowGesecCustomerRequest
    >({
      query: (request) => ({
        url: `/business-central/gesec/customer`,
        method: "GET",
        params: request,
      }),
    }),
    businessCentralGesecCustomerList: build.query<
      ODataList<GesecCustomer>,
      ListGesecCustomerRequest
    >({
      query: (request) => ({
        url: `/business-central/gesec/customer/list`,
        method: "GET",
        params: { request: btoa(JSON.stringify(request)) },
      }),
    }),
  }),
});

export const {
  useBusinessCentralGesecCustomerShowQuery,
  useBusinessCentralGesecCustomerListQuery,
} = customerApi;

export type ShowGesecCustomerRequest = {
  companyId: string;
  no: string;
};

export type ListGesecCustomerRequest = {
  companyId: string;
  name?: Filter<string>;
  limit?: number;
};
